<template>
  <div>
    <div class='h-toolbarBg'>
      <div class='e-control e-toolbar' >
        <ejs-toolbar ref='toolbar'>
          <e-items>
              <e-item id='add' prefixIcon='icon hero-icon hero-icon-add' :tooltipText='$t("Pm.add")' :click='addUserKPI'></e-item>
              <e-item id='activate' prefixIcon='icon hero-icon hero-icon-start-up' :tooltipText='$t("Pm.active")' :click='activateUserKPI'></e-item>
              <e-item id='goActivate' prefixIcon='icon hero-icon hero-icon-disable' :tooltipText='$t("Pm.inactive")' :click='inactivateUserKPI'></e-item>
              <e-item id='modify' prefixIcon='icon hero-icon hero-icon-edit' :tooltipText='$t("Pm.modify")' :click='editUserKPI' ></e-item>
              <e-item id='del' prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("Pm.del")' :click='delUserKPIBefore' ></e-item>
          </e-items>
        </ejs-toolbar>
        <div class="e-toolbar-items">
          <div class="e-toolbar-right">
            <div class="e-toolbar-item " >
              <div class="e-input-group e-search">
                <input class="e-input" :placeholder='$t("Pm.name")' v-model='searchString' maxlength="255"/>
                <span class="hero-icon hero-icon-search"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div>
        <input class="e-input" placeholder='名称' v-model='searchString'/>
        <span class="hero-icon hero-icon-search"></span>
      </div>-->
    </div>
    <ejs-grid ref='grid' :dataSource='searchDataForList' class='h100-60 h-scroll' :allowPaging='false'
    :allowSelection="true"  :selectionSettings="selectionOptions" :rowSelected='rowSelected' height='calc(100vh - 280px)'>
      <e-columns>
        <e-column field='counterCodeCn' :headerText='$t("Pm.name")' textAlign='center' width='20%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='counterCode' :headerText='$t("Pm.indicatorID")' textAlign='center' width='12%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='counterCodeSwitch2' :headerText='$t("Pm.indicatorState")' textAlign='center' width='10%'  :template='statusTemplate'></e-column>
        <e-column field='counterFormulaUi' :headerText='$t("Pm.indicatorFormulaColumn")' textAlign='center' width='23%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='counterUnitCn2' :headerText='$t("Pm.unit")' textAlign='center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='counterTypeMode' :headerText='$t("Pm.mode")' textAlign='center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='counterInvalidTime2' :headerText='$t("Pm.invalidTime")' textAlign='center' width='15%' clipMode='EllipsisWithTooltip'></e-column>
      </e-columns>
    </ejs-grid>
    <ejs-pager ref='pager' @click='getUserKpiListData()' :currentPage='pageSettings.currentPage' :pageCount='pageSettings.pageCount' :pageSize='pageSettings.pageSize' :totalRecordsCount='pageSettings.totalRecordsCount'></ejs-pager>

    <CustomDialog  ref='addKPIDialog1' :element='dialogForAddKPIPage1.element' :styles='dialogForAddKPIPage1.styles' :messages='dialogForAddKPIPage1.messages'>
      <template v-slot:dialog-content>
        <div class="h-dialogContainer">
          <form id='addKPI1'>
            <div class="row h-row-inputBox">
              <div class='col-sm-6 h-col-inputBox'>
                <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.indicatorName')}}:</div>
                <ejs-textbox name='taskName' :placeholder='$t("Pm.pleaseInput")' v-model="dialogParam.counterCodeCn"  @blur="blurOfCounterName"></ejs-textbox>
              </div>
              <div class="col-sm-6 h-col-inputBox">
                  <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.indicatorState')}}：</div>
                  <ejs-dropdownlist :dataSource='counterCodeSwitch' :placeholder='dialogParam.counterCodeSwitch' :value='dialogParam.counterCodeSwitch'
                  :change='changeCounterCodeSwitch' :fields='fields' :enabled="isAddMode"></ejs-dropdownlist>
              </div>
            </div>

            <div class="row h-row-inputBox">
              <div class="col-sm-6 h-col-inputBox">
                <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.indicatorDesc')}}:</div>
                <ejs-textbox name='taskDescription' :placeholder='$t("Pm.pleaseInput")' :value="dialogParam.counterCodeEn" :change='changeCounterCodeEn'></ejs-textbox>
              </div>
              <div class="col-sm-6 h-col-inputBox">
                <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.dataType')}}:</div>
                <ejs-dropdownlist :dataSource='dataType' :placeholder='dialogParam.dataType' :value='dialogParam.dataType' :change='changeDataType' :fields='fields' ></ejs-dropdownlist>
              </div>
            </div>

            <div class="row h-row-inputBox">
              <div class='col-sm-6 h-col-inputBox'>
                <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.resourceType')}}:</div>
                <ejs-textbox  :placeholder='$t("Pm.pleaseInput")' v-model="nodeParam.text.nodePPText" :readonly="true"></ejs-textbox>
              </div>
              <div class="col-sm-6 h-col-inputBox">
                <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.unit')}}:</div>
                <ejs-dropdownlist :dataSource='counterUnitCn' :placeholder='dialogParam.counterUnitCn' :value='dialogParam.counterUnitCn' :change='changeCounterUnitCn' :fields='fields' ></ejs-dropdownlist>
              </div>
            </div>

            <div class="row h-row-inputBox">
              <div class="col-sm-6 h-col-inputBox">
                <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.measurementObjectClassify')}}:</div>
                <ejs-textbox  :placeholder='$t("Pm.pleaseInput")' v-model="nodeParam.text.nodePText" :readonly="true"></ejs-textbox>
              </div>
              <div class="col-sm-6 h-col-inputBox">
                <div class="h-inputLit">{{$t('Pm.invalidTime')}}：</div>
                <ejs-datetimepicker  name='endTime' format='yyyy-MM-dd HH:mm:ss' :locale='locale' :value='dialogParam.counterInvalidTime' :change='changeCounterInvalidTime' :showClearButton='false'></ejs-datetimepicker>
              </div>
            </div>

            <div class="row h-row-inputBox">
              <div class="col-sm-6 h-col-inputBox">
                <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.measurementObject')}}</div>
                <ejs-textbox  :placeholder='$t("Pm.pleaseInput")' v-model="nodeParam.text.nodeText" :readonly="true"></ejs-textbox>
              </div>
              <div class="col-sm-6 h-col-inputBox">
                <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.targetErrorValue')}}:</div>
                <ejs-dropdownlist :dataSource='errValType' :placeholder='dialogParam.targetErrorValue' :value='dialogParam.targetErrorValue' :change='changeTargetErrorValue' :fields='fields' ></ejs-dropdownlist>
              </div>
            </div>
          </form>
        </div>
      </template>
    </CustomDialog>

    <CustomDialog ref='addKPIDialog2' :element='dialogForAddKPIPage2.element' :styles='dialogForAddKPIPage2.styles'  :messages='dialogForAddKPIPage2.messages'>
      <template v-slot:dialog-content>
        <AddKPI2 v-bind:nodeParam='nodeParam' :counterFormulaUi="counterFormulaUi" @formula='formula' @dataForList='getUserKPIList' v-bind:isAddMode='isAddMode' v-bind:isNextStep='isNextStep'></AddKPI2>
      </template>
    </CustomDialog>
    <QueryDialog ref='queryDialog' v-bind:content='queryDialogContent' @confirm='delUserKPI'/>
  </div>
</template>

<script>
import { GridPlugin, Reorder, Resize, ExcelExport, ContextMenu, Toolbar, Page, Selection, Edit, CommandColumn } from '@syncfusion/ej2-vue-grids';
import { FormValidator } from '@syncfusion/ej2-vue-inputs';
import { ClickEventArgs } from '@syncfusion/ej2-vue-navigations';
import { DateTimePickerPlugin } from '@syncfusion/ej2-vue-calendars';
import AddKPI2 from './dialog/addKPI2';
import CustomDialog from '../../../../common/CustomDialog';
import statusTemplate from './statusTemplate';
import QueryDialog from '../../../../common/queryDialog';
import { EventBus } from '../../../../../plugins/eventBus';
import dateUtil from '../../../util/DateUtil';

const INACTIVE = 0;
const ACTIVE = 1;
export default {
  name: 'customKPI',
  components: {
    CustomDialog,
    AddKPI2,
    QueryDialog,
    DateTimePickerPlugin
  },
  props: {
    nodeParam: {
      netypeid: '',
      measureobjecttypecode: '',
      countertypeid: '',
      neversionid: '',
      meterTimePeriod: 2,
      text: {
        nodeText: '',
        nodePText: '',
        nodePPText: ''
      },
      isLeaf: false
    }
  },
  data() {
    return {
      locale: localStorage.getItem('locale'),
      isChinese: true,
      selectionOptions: { type: 'Single' },
      pageSettings: {
        currentPage: 1,
        pageSize: 16,
        totalRecordsCount: 0,
        pageCount: 10
      },
      minDateTime: new Date(),
      dataForList: [],
      userKPIDataForList: [],
      searchString: '',
      rowData: {},
      isLeaf: false,
      isAddMode: false,
      isNextStep: false,
      queryDialogContent: `${this.$t('Pm.queryWillDel')} ?`,
      fields: { text: 'name', value: 'code' },
      dataType: [
        { name: 'int', code: '0'
        }, { name: 'long', code: '1'
        }, { name: 'float', code: '2'
        }],
      errValType: [
        { name: '0', code: '0'},
        { name: '100', code: '100'},
        { name: '--', code: 'null'}
      ],
      counterCodeSwitch: [
        { name: `${this.$t('Pm.inactive')}`, code: '0' },
        { name: `${this.$t('Pm.active')}`, code: '1' }
      ],
      counterUnitArr: [],
      counterUnitCn: [],
      dialogParam: {
        counterCodeCn: '',
        counterCodeEn: '',
        dataType: '',
        counterUnitCn: '',
        counterInvalidTime: '',
        counterCodeSwitch: '',
        targetErrorValue: '',
        // counterFormulaUi: '', //  children to parent
      },
      counterFormulaUi: '', // parent to children
      systemId: '1',
      timecycle: 2,
      configUserKpiInfo: {
        activityVersion: '',
        counterCode: '',
        counterCodeCn: '',
        counterCodeEn: '',
        counterCodeSwitch: '1',
        counterCreatePeople: 'username',
        counterFormula: '',
        counterFormulaUi: '',
        counterIndex: '1',
        counterInvalidTime: null,
        counterPrecisionFlag: '0',
        counterType: '3',
        counterTypeId: '',
        counterTypeMode: 'TDD/FDD',
        counterUnitCn: '',
        counterUnitEn: '',
        counterUnitId: '',
        counterValueType: '0',
        dataDisposeMode: '',
        dataType: 'int',
        meterTimePeriod: '2',
        neTypeId: '',
        neVersionId: '',
        serviceModule: `${this.$t('Pm.cellMeasure')}`,
        targetErrorValue: 'null',
      },
      dialogForAddKPIPage1: {
        styles: {
          // width: '60%',
          // height: '80%',
          visible: false,
          model: true
        },
        element: {
          target: this.$refs.grid,
          refName: 'dialogForAddKPIPage1',
          buttonGroup: [
            { click: this.closeAddKPIPage1, buttonModel: { content: `${this.$t('Common.cancel')}` } },
            { click: this.nextForTask, buttonModel: { content: `${this.$t('Pm.nextStep')}` } }
          ],
          isClose: true,
          title: `${this.$t('Pm.createTask')}: ${this.$t('Pm.first')}`
        },
        messages: {
          title: `${this.$t('Pm.createTask')}: ${this.$t('Pm.first')}`
        }

      },
      dialogForAddKPIPage2: {
        styles: {
        //   width: '60%',
        //   height: '80%',
          visible: false,
          model: true,
          zIndex: 1100
        },
        element: {
          target: this.$refs.grid,
          refName: 'dialogForAddKPIPage2',
          buttonGroup: [
            { click: this.closeAddKPIPage2, buttonModel: { content: `${this.$t('Common.cancel')}` } },
            { click: this.preForTask, buttonModel: { content: `${this.$t('Pm.preStep')}` } },
            { click: this.submitTask, buttonModel: { content: `${this.$t('Pm.finish')}`, isPrimary: true } }
          ],
          isClose: true,
          title: `${this.$t('Pm.createTask')}: ${this.$t('Pm.second')}`
        },
        messages: {
          title: `${this.$t('Pm.createTask')}: ${this.$t('Pm.second')}`
        }

      },
      statusTemplate(args) {
        return {
          template: statusTemplate
        };
      },
      validationOption: {
        customPlacement(inputElement, errorElement) {
          errorElement.style.float = 'left';
          inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {
          taskName: {
            required: [true, `${this.$t('Pm.alertRequired')}`],
            maxLength: [255, `${this.$t('Pm.alertMaxLength')}255`],
            regex: [/^([^('"\\<>\s)])([^'"\\<>\s]*)$/, `${this.$t('Pm.notInputSpace')}，${this.$t('Alarm.notInput')}' " \\ < >`],//(/^([^('"\\<>)|(\d)|(\s)])([^'"\\<>]*)$/)

          },
          taskDescription: {
            required: [true, `${this.$t('Pm.alertRequired')}`],
            maxLength: [255, `${this.$t('Pm.alertMaxLength')}255`],
            regex: [/(^(?![0-9]|(\s)))(^((?!['\\"<>]).)+$)/, `${this.$t('Pm.alertIsNumberHeader')}，${this.$t('Alarm.notInput')}' " \\ < >`],
          },
          endTime: {
            // required: [false, `${this.$t('Alarm.enddatenull')}`],
            // dateIso: [true, `${this.$t('Pm.alertInvalidDate')}`]
            regex: [/^((([0-9]{3}[1-9]|[0-9]{2}[1-9][0-9]{1}|[0-9]{1}[1-9][0-9]{2}|[1-9][0-9]{3})-(((0[13578]|1[02])-(0[1-9]|[12][0-9]|3[01]))|((0[469]|11)-(0[1-9]|[12][0-9]|30))|(02-(0[1-9]|[1][0-9]|2[0-8]))))|((([0-9]{2})(0[48]|[2468][048]|[13579][26])|((0[48]|[2468][048]|[3579][26])00))-02-29))\s([0-1][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/, `${this.$t('Pm.alertInvalidDate')}`]
          }
        }
      },
      timerArr: [],
      preAction: false,
      hasSame: false,
      oldSearchString: '',
      counterCodeNameCache: ''
    };
  },
  methods: {
    blurOfCounterName(event) {
      const msg = event.value;
      if (msg != null && msg != '' && msg.indexOf('USER_') == -1) {
        this.dialogParam.counterCodeCn = `USER_${msg}`;
      }
      this.configUserKpiInfo.counterCodeCn = this.dialogParam.counterCodeCn;
    },
    changeCounterCodeEn(event) {
      this.configUserKpiInfo.counterCodeEn = event.value;
    },
    changeCounterCodeSwitch(event) {
      this.configUserKpiInfo.counterCodeSwitch = event.value;
    },
    changeDataType(event) {
      // console.log('changeDataType',event.value)
      if (event.value) {
        this.configUserKpiInfo.dataType = this.dataType.filter(item => item.code === event.value)[0].name;
      }
    },
    changeTargetErrorValue(event) {
      // console.log('changeDataType',event.value)
      if (event.value) {
        this.configUserKpiInfo.targetErrorValue = this.errValType.filter(item => item.code === event.value)[0].code;
      }
    },
    changeCounterUnitCn(event) {
      this.configUserKpiInfo.counterUnitId = event.value;
      this.configUserKpiInfo.counterUnitCn = this.switchCounterUnitLanguage(true, event.value);
      this.configUserKpiInfo.counterUnitEn = this.switchCounterUnitLanguage(false, event.value);
    },
    changeCounterInvalidTime(event) {
      this.configUserKpiInfo.counterInvalidTime = !event.value ? null : dateUtil.getDateString(event.value);
    },
    rowSelected(event) {
      this.rowData = event.data;
      // console.log('rowSelected',this.rowData)
      this.$refs.toolbar.enableItems(4, true);

      if (this.isLeaf) {
        this.$refs.toolbar.enableItems([0, 3], true);
      }

      if (this.rowData.counterCodeSwitch === ACTIVE) {
        this.$refs.toolbar.enableItems(1, false);
        this.$refs.toolbar.enableItems(2, true);
      } else {
        this.$refs.toolbar.enableItems(1, true);
        this.$refs.toolbar.enableItems(2, false);
      }
    },
    getUserKPIList(payload) {
      this.userKPIDataForList = payload;
    },
    formatDataStr(val) {
      const dateValue = new Date(val);
      let month = dateValue.getMonth() + 1;
      if (month < 10) {
        month = `0${month}`;
      }
      let day = dateValue.getDate();
      if (day < 10) {
        day = `0${day}`;
      }
      let hours = dateValue.getHours();
      if (hours < 10) {
        hours = `0${hours}`;
      }
      let minutes = dateValue.getMinutes();
      if (minutes < 10) {
        minutes = `0${minutes}`;
      }
      let seconds = dateValue.getSeconds();
      if (seconds < 10) {
        seconds = `0${seconds}`;
      }
      return `${dateValue.getFullYear()}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    getSelectedRecords() {
      return this.$refs.grid.getSelectedRecords();
    },
    formula(payload) {
      this.configUserKpiInfo.counterFormula = payload;
      this.configUserKpiInfo.counterFormulaUi = payload;
    },
    initAddUserKPI() {
      this.dialogParam = {
        counterCodeCn: '',
        counterCodeEn: '',
        dataType: '0',
        counterUnitCn: (this.counterUnitCn.length > 0) ? this.counterUnitCn[0].code : '',
        counterInvalidTime: null,
        counterCodeSwitch: '1',
        targetErrorValue: 'null',
      };
      this.counterFormulaUi = '';
      this.configUserKpiInfo.counterInvalidTime = null;
    },
    addUserKPI() {
      this.isAddMode = false;
      this.initAddUserKPI();
      this.$refs.addKPIDialog1.show();
      this.bindValidate();
    },
    closeAddKPIPage1() {
      this.$refs.addKPIDialog1.close();
    },
    nextForTask() {
      if (!this.validate()) {
        return;
      }
      // console.log('this.isAddMode',this.isAddMode,this.rowData.counterFormulaUi,this.configUserKpiInfo)
      this.counterFormulaUi = !this.preAction ? '' : this.configUserKpiInfo.counterFormula;
      if (this.isAddMode) {
        this.counterFormulaUi = !this.preAction ? this.rowData.counterFormulaUi : this.configUserKpiInfo.counterFormula;
      }
      this.preAction = false;
      this.isNextStep = !this.isNextStep;
      this.$refs.addKPIDialog1.close();
      this.$refs.addKPIDialog2.show();
    },
    preForTask() {
      this.preAction = true;
      this.dialogParam.counterCodeCn = this.configUserKpiInfo.counterCodeCn;
      this.dialogParam.counterCodeEn = this.configUserKpiInfo.counterCodeEn;
      this.dialogParam.counterCodeSwitch = this.configUserKpiInfo.counterCodeSwitch;
      this.dialogParam.counterUnitCn = this.configUserKpiInfo.counterUnitId;
      this.dialogParam.dataType = this.configUserKpiInfo.dataType;
      this.dialogParam.counterInvalidTime = !this.configUserKpiInfo.counterInvalidTime ? null : new Date(this.configUserKpiInfo.counterInvalidTime);

      this.$refs.addKPIDialog2.close();
      this.$refs.addKPIDialog1.show();
      this.bindValidate();
    },
    closeAddKPIPage2() {
      this.$refs.addKPIDialog2.close();
    },
    findUserKPICode(formulaUi, flag, number) {
      let pos = number;
      const { length } = formulaUi;
      let substr = '';
      if ((pos + 10) <= length) {
        substr = formulaUi.substr(pos, 11);
        const list = this.userKPIDataForList.filter(item => (item.counterCode.indexOf(substr) !== -1));
        if (list.length === 0) {
          return true;
        }

        pos = formulaUi.indexOf(flag, pos + 11);
        if (pos === -1) {
          return false;
        }
        return this.findUserKPICode(formulaUi, flag, pos);
      }

      return true;
    },
    submitTask() {
       //console.log('this.dialogParam.counterFormulaUi',this.configUserKpiInfo.counterInvalidTime, this.configUserKpiInfo.counterCodeSwitch)

      let show = false;
      let errorInfo = '';
      const formulaUi = String(this.configUserKpiInfo.counterFormulaUi);
      const { length } = formulaUi;
      if (formulaUi === '' || this.configUserKpiInfo.counterFormulaUi === undefined) {
        errorInfo = `${this.$t('Pm.alertFormula1')}`;
        show = true;
      } else if (length > 512) {
        errorInfo = `${this.$t('Pm.alertFormula4')}`;
        show = true;
      } else {
        const pos = formulaUi.indexOf('C');
        errorInfo = (pos === -1) ? `${this.$t('Pm.alertFormula2')}` : `${this.$t('Pm.alertFormula3')}`;
        show = (pos === -1) ? true : this.findUserKPICode(formulaUi, 'C', pos);
      }

      if (show) {
        EventBus.$emit('toast', {type: 'warning', content:errorInfo});

        return;
      }

      if(this.configUserKpiInfo.counterInvalidTime !==null && this.configUserKpiInfo.counterCodeSwitch ==='1'){
        const now = Date.parse(new Date()) || 0; // ms
        const createTaskTime = Date.parse(this.configUserKpiInfo.counterInvalidTime )|| 0; // ms

        //console.log('result',createTaskTime-now,now,createTaskTime)
        if((createTaskTime-now) <=0){
          const errorInfo = `${this.$t('Pm.alertInvalidTime')}`;
          EventBus.$emit('toast', {type: 'warning', content: errorInfo});

          return;
        }

      }

      if (!this.isAddMode) {
        this.addUserKPIInfo();
      } else {
        this.updateUserKPIInfo();
      }
    },
    getUnitsbyNeTypeId() {
      this.$axios.post(`/lte/pm/indicator/getUnitsbyNeTypeId.html?netypeid=${this.nodeParam.netypeid}`).then((response) => {
        if (response.status !== 200 || response.data === undefined) {
          return;
        }
        this.counterUnitArr = response.data;
        this.counterUnitCn = this.counterUnitArr.filter(item => item.counterUnitCn !== '' && item.counterUnitEn !== '').map(item => {
          const name = this.isChinese ? item.counterUnitCn : item.counterUnitEn;
          const code = item.counterUnitId;
          return {
            name, code
          };
        })
        this.dialogParam.counterUnitCn = (this.counterUnitCn.length > 0) ? this.counterUnitCn[0].code : '';//
      }).catch((error) => { // 请求失败处理
        console.log('error', error);
      });
    },
    computeUserKpiTime(record) {
      let result = 0;
      const taskTimeLength = record.counterInvalidTime || 0; // s
      const now = Date.parse(new Date()) || 0; // ms
      const createTaskTime = Date.parse(record.counterCreateTime) || 0; // ms

      result = (taskTimeLength - (now - createTaskTime)) / 1000;
      if (result > taskTimeLength) {
        result = taskTimeLength;
      }

      return result;
    },
    initUserKpiListData() {
      for (const timerInfo of this.timerArr) {
        clearInterval(timerInfo.timer);
      }
      this.timerArr = [];
      for (let item of this.dataForList) {
        switch (item.counterCodeSwitch) {
          case ACTIVE:
            item.counterCodeSwitch2 = `${this.$t('Pm.active')}`;
            break;
          case INACTIVE:
            item.counterCodeSwitch2 = `${this.$t('Pm.inactive')}`;
            break;
          default:
            item.counterCodeSwitch2 = `${this.$t('Pm.active')}`;
            break;
        }

        item.counterInvalidTime2 = !item.counterInvalidTime ? null : this.formatDataStr(item.counterInvalidTime);
        item.counterUnitCn2 = this.locale === 'zh'?item.counterUnitCn:item.counterUnitEn;
        let result = this.computeUserKpiTime(item);
        if (item.counterCodeSwitch === ACTIVE) {
          this.rowData = item;
          if (result <= 0) {
            if (item.counterInvalidTime === null) {
              continue;
            }
            // else{
            //   // exception default to do active
            //   if(item.counterIndex === ACTIVE){
            //     this.rowData = item;
            //     this.activateUserKPI(false);
            //   }
            // }
            this.inactivateUserKPI(false);
          } else {
            if (item.counterInvalidTime === null) {
              continue;
            }
            const _this = this;
            const timer = setInterval(() => {
              if (result <= 0) {
                clearInterval(timer);
                _this.rowData = item;
                _this.inactivateUserKPI(false);
                _this.timerArr = _this.timerArr.filter(item => item.timer !== timer);
              }
              result = _this.computeUserKpiTime(item);
              // console.log('timer:',timer,item.counterCodeCn,result);
            }, 1000);

            const timerInfo = {
              timer: timer,
              counterCode: item.counterCode,
            }
            this.timerArr.push(timerInfo);
          }
        }
      }
    },
    getUserKpiListData() {
      const This = this;
      This.pageSettings.currentPage = This.$refs.pager.ej2Instances.currentPage;
      this.$axios.post('/lte/pm/indicator/userKpiListData.html', {
        page: {
          pageNo: This.pageSettings.currentPage,
          pageSize: This.pageSettings.pageSize
        },
        netypeid: this.nodeParam.netypeid,
        measureobjecttypecode: this.nodeParam.measureobjecttypecode,
        countertypeid: this.nodeParam.countertypeid,
        neversionid: this.nodeParam.neversionid,
        systemId: this.systemId,
        timecycle: this.nodeParam.meterTimePeriod,
        indicatorname:this.oldSearchString
      }).then((response) => {
        if (response.status !== 200 || response.data === undefined) {
          return;
        }
        if (response.data.errorCode === 'SUCCESS') {
          const result = response.data.resultVal;
          This.pageSettings.totalRecordsCount = result.totalCount;
          This.pageSettings.currentPage = result.pageNo;
          This.dataForList = result.result;
          this.initUserKpiListData();
        } else {
          console.log('error', response.data.errorCode);
        }
      }).catch((error) => { // 请求失败处理
        console.log('error', error);
      });
      this.$refs.toolbar.enableItems([1, 2, 3, 4], false);
    },
    switchCounterUnitLanguage(isCn, code) {
      const unitSwitchData = this.counterUnitArr.filter(item => item.counterUnitId === code);
      let result = '';
      if (unitSwitchData.length > 0) {
        result = isCn ? unitSwitchData[0].counterUnitCn : unitSwitchData[0].counterUnitEn;
      }

      return result;
    },
    setConfigUserInfo() {
      this.configUserKpiInfo.counterCode = this.isAddMode ? this.rowData.counterCode : '';
      this.configUserKpiInfo.activityVersion = this.nodeParam.neversionid;
      this.configUserKpiInfo.counterTypeId = this.nodeParam.countertypeid;
      this.configUserKpiInfo.neTypeId = this.nodeParam.netypeid;
      this.configUserKpiInfo.neVersionId = this.nodeParam.neversionid;
      this.configUserKpiInfo.serviceModule = this.nodeParam.text.nodePText;
      this.configUserKpiInfo.meterTimePeriod = this.nodeParam.meterTimePeriod;
    },
    async addUserKPIInfo() {
      await this.$axios.get(`/lte/pm/indicator/hasSameNameIndicator.html?indactorName=${this.configUserKpiInfo.counterCodeCn}`).then((response) => {
        this.hasSame = response.data.resultVal;
      }).catch((error) => {
        console.log('error', error);
      });

      if (this.hasSame) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Pm.hasSameIndicatorName')});

        return;
      }

      this.setConfigUserInfo();
      this.$loading.showLoadding(this.$t('System.loading'));
      this.$axios.post('/lte/pm/indicator/addUserKpiInfo.html', {
        configUserKpiInfo: this.configUserKpiInfo
      }).then((response) => {
        this.$loading.hideLoadding();
        if (response.status !== 200 || response.data === undefined) {
          return;
        }
        if (response.data.errorCode === 'SUCCESS') {
          this.$refs.addKPIDialog2.close();
          this.getUserKpiListData();
        } else {
          EventBus.$emit('toast', {type: 'warning', content: response.data.errorCode});

        }
      }).catch((error) => { // 请求失败处理
        console.log('error', error);
      });
    },
    async updateUserKPIInfo() {
      await this.$axios.get(`/lte/pm/indicator/hasSameNameIndicator.html?indactorName=${this.configUserKpiInfo.counterCodeCn}`).then((response) => {
        this.hasSame = response.data.resultVal;
      }).catch((error) => {
        console.log('error', error);
      });

      if (this.hasSame && this.counterCodeNameCache != this.configUserKpiInfo.counterCodeCn) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Pm.hasSameIndicatorName')});

        return;
      }

      this.setConfigUserInfo();
      this.$loading.showLoadding(this.$t('System.loading'));
      this.$axios.post('/lte/pm/indicator/updateUserKpi.html', {
        configUserKpiInfo: this.configUserKpiInfo
      }).then((response) => {
        this.$loading.hideLoadding();
        if (response.status !== 200 || response.data === undefined) {
          return;
        }
        if (response.data.errorCode === 'SUCCESS') {
          this.$refs.addKPIDialog2.close();
          this.getUserKpiListData();
        } else {
          EventBus.$emit('toast', {type: 'warning', content: response.data.errorCode});

        }
      }).catch((error) => { // 请求失败处理
        console.log('error', error);
      });
    },
    delUserKPIBefore() {
      const selectedRecords = this.getSelectedRecords();
      if (selectedRecords.length === 0) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Pm.alertData1')});

        return;
      }
      this.$refs.queryDialog.show();
    },
    delUserKPI() {
      this.$axios.post('/lte/pm/indicator/deleteUserKpiInfo.html', this.rowData).then((response) => {
        if (response.status !== 200 || response.data === undefined) {
          return;
        }
        if (response.data.errorCode === 'SUCCESS') {
          this.getUserKpiListData();
        } else {
          EventBus.$emit('toast', {type: 'warning', content: response.data.errorCode});

        }
      }).catch((error) => { // 请求失败处理
        console.log('error', error);
      });
    },
    editUserKPI() {
      const selectedRecords = this.getSelectedRecords();
      if (selectedRecords.length === 0) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Pm.alertData1')});

        return;
      }
      this.isAddMode = true;
      this.dialogParam = selectedRecords[0];
      this.dialogParam.counterCodeSwitch = String(selectedRecords[0].counterCodeSwitch);
      this.dialogParam.counterInvalidTime = !selectedRecords[0].counterInvalidTime2?null:new Date(selectedRecords[0].counterInvalidTime2);
      this.dialogParam.counterUnitCn = selectedRecords[0].counterUnitId;

      // console.log('selectedRecords[0]',selectedRecords[0])
      this.configUserKpiInfo.counterCodeCn = selectedRecords[0].counterCodeCn;
      this.counterCodeNameCache = selectedRecords[0].counterCodeCn;
      this.configUserKpiInfo.counterCodeEn = selectedRecords[0].counterCodeEn;
      this.configUserKpiInfo.counterCodeSwitch = selectedRecords[0].counterCodeSwitch;
      this.configUserKpiInfo.dataType = selectedRecords[0].dataType;
      this.configUserKpiInfo.counterUnitId = selectedRecords[0].counterUnitId;
      this.configUserKpiInfo.counterUnitCn = this.switchCounterUnitLanguage(true, selectedRecords[0].counterUnitId);
      this.configUserKpiInfo.counterUnitEn = this.switchCounterUnitLanguage(false, selectedRecords[0].counterUnitId);;
      this.configUserKpiInfo.counterFormula = selectedRecords[0].counterFormulaUi;
      this.configUserKpiInfo.counterFormulaUi = selectedRecords[0].counterFormulaUi;
      this.configUserKpiInfo.counterInvalidTime = selectedRecords[0].counterInvalidTime2;
      this.$refs.addKPIDialog1.show();
      this.bindValidate();
    },
    activateUserKPI(show) {
      if(show){
        const selectedRecords = this.getSelectedRecords();
        if (selectedRecords.length === 0) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Pm.alertData1')});

          return;
        }
      }

      this.rowData.counterIndex = ACTIVE;
      this.$axios.post('/lte/pm/indicator/activeKpi.html', this.rowData).then((response) => {
        if (response.status !== 200 || response.data === undefined) {
          return;
        }
        if (response.data.errorCode === 'SUCCESS') {
          if (show) {
            EventBus.$emit('toast', {type: 'success', content: this.$t('Pm.successInfo')});

          }
          this.getUserKpiListData();
        }
      }).catch((error) => { // 请求失败处理
        console.log('error', error);
      });
    },
    inactivateUserKPI(show) {
      if (show) {
        const selectedRecords = this.getSelectedRecords();
        if (selectedRecords.length === 0) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Pm.alertData1')});

          return;
        }
      }

      this.rowData.counterIndex = INACTIVE;
      this.$axios.post('/lte/pm/indicator/activeKpi.html', this.rowData).then((response) => {
        if (response.status !== 200 || response.data === undefined) {
          return;
        }
        if (response.data.errorCode === 'SUCCESS') {
          if (show) {
            EventBus.$emit('toast', {type: 'success', content: this.$t('Pm.successInfo')});

          }
          this.getUserKpiListData();
        }
      }).catch((error) => { // 请求失败处理
        console.log('error', error);
      });
    },
    bindValidate() {
      this.formObj = new FormValidator('#addKPI1', this.validationOption);
    },
    validate() {
      const formStatus = this.formObj.validate();
      return formStatus;
    }

  },
  mounted() {
    this.$refs.toolbar.enableItems([0, 1, 2, 3, 4], false);
    this.locale = this._i18n.locale;
    if (this.locale !== 'zh') {
      this.isChinese = false;
    }
  },
  computed: {
    searchDataForList(val) {
      const searchString = this.searchString.trim().toLowerCase();

      if (this.oldSearchString === searchString) {//!searchString ||
        return this.dataForList;
      }

      this.oldSearchString = searchString;
      this.$refs.pager.ej2Instances.currentPage = 1;
      this.getUserKpiListData();

      return  this.dataForList;
    },
  },
  watch: {
    nodeParam(val) {
      // console.log('nodeParam',val)
      this.$refs.grid.clearSelection();
      this.nodeParam = val;
      this.$refs.pager.ej2Instances.currentPage = 1;
      this.isLeaf = val.isLeaf;
      this.$refs.toolbar.enableItems([1, 2, 3, 4], false);

      this.getUserKpiListData();
      this.getUnitsbyNeTypeId();
    },
    isLeaf(isLeaf) {
      if (isLeaf) {
        this.$refs.toolbar.enableItems(0, true);
        return;
      }
      this.$refs.toolbar.enableItems(0, false);
    },

  },
  provide: {
    grid: [Reorder, Resize, ExcelExport, ContextMenu, Toolbar, Page, Selection, Edit, CommandColumn]
  }
};
</script>
